// extracted by mini-css-extract-plugin
module.exports = {"graph":"AreaGraph_graph__SpzYz","graphText":"AreaGraph_graphText__nuXRw","graphTimeLabel":"AreaGraph_graphTimeLabel__JemS9","nowLabel":"AreaGraph_nowLabel__ctEqV"};